import { Link } from "react-router-dom";
import PageShell from "../../components/PageShell";
import { OperatorLabCrumb, ARTICLE_META } from "./_shared";

const ARTICLES = ARTICLE_META;

export default function OperatorLabIndex() {
  return (
    <PageShell title="Operator Lab — Buyer Guides & Deep-Dives · Loadout" description="Gaming peripheral buyer guides for Indian players — mouse shapes and aim, mousepad surfaces, Hall Effect vs mechanical keyboards, and ₹15,000 loadout builds." path="/operator-lab">
      <div className="mb-10">
        <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-[#F59E0B]" data-testid="operator-lab-eyebrow">05 / Operator Lab</p>
        <h1 className="mt-4 font-display uppercase leading-[0.95] text-[40px] sm:text-[52px] lg:text-[64px] text-white" data-testid="operator-lab-heading">
          Long-form buyer guides,<br />
          <span className="text-[#F59E0B]">comparison articles,</span>
          <br />
          verified benchmarks.
        </h1>
        <p className="mt-6 text-white/70 leading-relaxed text-[15px] max-w-[68ch]">
          Field notes from the Loadout bench. No affiliate junk, no fabricated benchmarks — just the gear we actually stock, tested against the games our customers actually play.
        </p>
      </div>

      <ul className="mt-12 border-t border-white/10" data-testid="operator-lab-articles">
        {ARTICLES.map((a) => (
          <li key={a.slug} className="border-b border-white/10">
            <Link
              to={`/operator-lab/${a.slug}`}
              data-testid={`operator-lab-article-${a.slug}`}
              className="grid md:grid-cols-[180px_1fr_auto] gap-6 py-8 hover:bg-white/[0.02] transition-colors group -mx-6 px-6"
            >
              <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-white/50 group-hover:text-[#F59E0B] transition-colors">
                {a.category}
              </div>
              <div>
                <h2 className="font-display uppercase leading-tight text-[20px] md:text-[26px] text-white group-hover:text-[#F59E0B] transition-colors">
                  {a.title}
                </h2>
                <p className="mt-3 text-white/60 leading-relaxed text-[14px] max-w-[64ch]">
                  {a.excerpt}
                </p>
              </div>
              <div className="font-mono text-[10px] tracking-[0.16em] uppercase text-white/40 md:text-right md:self-start md:pt-2">
                {a.readingTime}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </PageShell>
  );
}
